import { render, staticRenderFns } from "./tevkifatbaglanti.vue?vue&type=template&id=2db5c2ad"
import script from "./tevkifatbaglanti.vue?vue&type=script&lang=js"
export * from "./tevkifatbaglanti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports